export default {
  unavailable: {
    title: 'Kundefakturaer er ikke tilgængelige',
    description:
      'Gæster, der bestiller hos dine restauranter, kan ikke anmode om en faktura, så der er intet at konfigurere her. Ordrekvitteringer og de fakturaer, din udbyder udsteder til dig, påvirkes ikke.',
  },
};
